import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/msw',
    redirect: { name: 'mswcreators' },
    children: [
      {
        path: 'mswcreators',
        name: 'mswcreators',
        component: () => import(/* webpackChunkName: "mswcreators" */ '@/views/mswcreators/index.vue'),
      },
      {
        path: 'landing',
        name: 'landing',
        component: () => import(/* webpackChunkName: "msw-landing" */ '@/views/landing/index.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'landing' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  base: '/msw/',
  routes,
})

export { router, routes }
